import React from 'react';
import styles from "./Loader.module.css";

function Loader() {
  return (
    <div className={styles.loaderWrapper}>
        <div className={styles.loaderBox}>Loader...</div>
    </div>
  )
}

export default Loader;